<template>
  <div class="section">
    <div class="ui middle aligned very relaxed center aligned stackable equal width grid container">
      <div class="column">
        <h1 class="ui left aligned header">
          Token functionality
          <div class="ui half hidden divider"></div>
          <div class="sub header">
            The Aragon Network aims to be the first decentralized jurisdiction. It will provide an optimal environment for decentralized organizations to thrive, by offering services such as easy smart contract upgradeability and a decentralized court. Token holders will be able to:
          </div>
        </h1>
        <div class="ui hidden divider"></div>
        <div class="ui list">
          <div class="item">
            <i class="checkmark icon"></i>
            <div class="content">
              Change subscription fees and minting rate
            </div>
          </div>
          <div class="item">
            <i class="checkmark icon"></i>
            <div class="content">
              Decide which services to provide
            </div>
          </div>
          <div class="item">
            <i class="checkmark icon"></i>
            <div class="content">
              Vote on capital allocations or investments
            </div>
          </div>
          <div class="item">
            <i class="checkmark icon"></i>
            <div class="content">
              Self-upgrade the Network
            </div>
          </div>
          <div class="item">
            <i class="checkmark icon"></i>
            <div class="content">
              All other voting and governance decisions
            </div>
          </div>
        </div>
      </div>
      <div class="column tokenGraph">
        <img class="ui fluid image" src="https://docs.google.com/drawings/d/1nBxz5ji9qyrZOt2MOgTOpIwmctsEFI5HK3LzFxy1oVM/pub?w=1651&h=1489" v-on:click="expandGraph">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tokenSummary',
  methods: {
    expandGraph() {
      window.$('.tokenGraph').toggleClass('sixteen wide')
    },
  },
}
</script>

<style scoped>
.list .item .content {
  font-weight: lighter;
  font-size: 1.25rem;
}
.image {
  cursor: zoom-in;
}
</style>



// WEBPACK FOOTER //
// TokenSummary.vue?021bd026